import { render, staticRenderFns } from "./EditorComments.vue?vue&type=template&id=230b9cad&"
import script from "./EditorComments.vue?vue&type=script&lang=js&"
export * from "./EditorComments.vue?vue&type=script&lang=js&"
import style0 from "./EditorComments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports